<template>
    <div>
        <b-row class="g-0">
            <b-col v-if="!!title" cols="2" class="d-flex justify-content-center align-items-center">
                <b> {{ title }}</b>
            </b-col>
            <b-col cols="5" v-if="!!filters.find(x => x === 'assetSearch')">
                <b-form-input id="input-to" type="text" v-model="assetSearch" :placeholder="$translate('asset_search')"
                    size="sm" class=""></b-form-input>
            </b-col>
            <b-col lg="2" cols="12" class="dd" v-if="!!filters.find(x => x === 'role')">
                <b-form-select id="input-role" v-model="role" :options="roles" size="sm"
                    class="form-select col-6 pe-0 form-control">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('any_role') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="12" lg="2" class="dd" v-if="!!filters.find(x => x === 'officer')">
                <b-form-select id="input-officer" v-model="officer" :options="officers" size="sm"
                    class="form-select form-control">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('any_officer') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" lg="4" class="dd" v-if="!!filters.find(x => x === 'orderType')">
                <b-form-select id="input-order-type" v-model="orderType" :options="orderTypes" size="sm"
                    class="form-select form-control">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('any_activity_type') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="5" class="dd" v-if="!!filters.find(x => x === 'assetType')">
                <b-form-select id="input-asset-type" v-model="assetType" :options="assetTypes" size="sm"
                    class="form-select form-control">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('any_asset_type') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>

            <b-col cols="12" lg="2" v-if="!!filters.find(x => x === 'dataRange')">
                <b-form-input id="input-from" type="date" v-model="range.from" :min="startYear" :max="endYear" size="sm"
                    class="calender" ref="inputFrom" @click="openCalendar($event)"></b-form-input>
            </b-col>
            <b-col cols="12" lg="2" v-if="!!filters.find(x => x === 'dataRange')">
                <b-form-input id="input-to" type="date" v-model="range.to" :min="startYear" :max="endYear" size="sm"
                    class="calender" ref="inputFrom" @click="openCalendar($event)"></b-form-input>
            </b-col>

            <!-- //for location  -->
            <b-col cols="5" class="dd" v-if="!!filters.find(x => x === 'location-role')">
                <b-form-select id="input-role" v-model="role" :options="roles" size="sm" class="form-select form-control">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('any_role') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
            <b-col cols="5" class="dd" v-if="!!filters.find(x => x === 'location-officer')">
                <b-form-select id="input-officer" v-model="officer" :options="officers" size="sm"
                    class="form-select form-control">
                    <template #first>
                        <b-form-select-option :value="null">{{ $translate('any_officer') }}</b-form-select-option>
                    </template>
                </b-form-select>
            </b-col>
        </b-row>
    </div>
</template>

<script>
const todayDate = new Date().toISOString().split('T')[0]
const sevenMonthEralier = new Date(Date.now() - 30 * 24 * 60 * 60 * 1000)
    .toISOString()
    .split('T')[0]
export default {
    data() {
        return {
            assetSearch: null,
            officer: null,
            role: null,
            orderType: null,
            assetType: null,
            range: {
                from: sevenMonthEralier,
                to: todayDate,
            },
            filter : {}
        }
    },
    props: {
        title: { type: String, default: () => null },
        officers: { type: Array, default: () => [] },
        roles: { type: Array, default: () => [] },
        orderTypes: { type: Array, default: () => [] },
        assetTypes: { type: Array, default: () => [] },
        filters: { type: Array, default: () => [] },
        startYear: { type: String },
        endYear:{ type: String },
    },
    methods: {
        openCalendar(e) {
            console.log(e.target.focus(), "focus");
            e.target.focus();
        },
    },
    computed:{
        user() {
      const _user = this.$store.state.user;
      console.log("user-----------", _user);
      return _user;
    },
    },
    async mounted() {
       
       
        if(this.$store.state.users.filters != null){
            
            let filter = this.$store.state.users.filters;
            if(filter.officer != null && filter.officer > 0){
              
                this.officer = filter.officer;
            }else{
              
                this.officer = this.user.id;
            }
        }else{
           
            this.officer = this.user.id;
        }
      
       this.$set(this.filters, 'officer', this.officer);
       await this.$store.dispatch("users/set_dashboard_filter",this.filters);
    },
    watch: {
        assetSearch: function (val) {
            this.$emit('asset-search', val)
        },

         officer: async function (val) {
            
            this.$set(this.filters, 'officer', val);
            await this.$store.dispatch("users/set_dashboard_filter",this.filters);
            
            this.$emit('select-officer', val)
        },

        role: function (val) {
            this.officer = null
            this.$emit('select-role', val)
        },

        assetType: function (val) {
            this.$emit('select-asset-type', val)
        },

        orderType: function (val) {
            this.$emit('select-order-type', val)
        },

        range: {
            handler: function (val) {
                this.$emit('select-range', val)
            },
            deep: true,
        },
    },
}
</script>
<style>
.row.no-gutters {
    margin-right: -6px !important;
    margin-left: -6px !important;
}

@media (max-width: 767.98px) {
    .leaflet-left {
        margin-top: 40px !important;
    }

    .leaflet-right {
        margin-left: 10px !important;
    }
}
</style>
